import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
    Combo2Service,
    ExcelService,

    PurchaseReportService
} from "../../../services/index";
import { SalesOrderService } from "../../../services";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./plainSostatus.html",
})
export class plainSostatus implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  qualityList: any;
  // typeList = ["RECEIVED", "PENDING", "BULK PENDING - ALL PARTY"];
  
  codeList: any;
  widthList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  exceldata: any;
  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  coreList = ["CORE", "NEW", "BOTH"];
  colorList=["lightblue", "pink"];
  filter = {
    groupby: "design_wise",
    coregroupby: "Purchase",
    party_code: "",
    party_name: "",
    fin_id: "4",
    agent: "",
    transport: "",
    color: [],
    design_no: "",
    shade: "",
    width: [],
    quality: [],
    type: "",
    sample_cut: [],
    swatch_cut: [],
    po_from_date: "",
    po_to_date: "",
    order_from: "",
    order_to: "",
    mtr_from: "",
    mtr_to: "",
    rate_from: "",
    rate_to: "",
    po_id: "",
    finyear: "",
    style : ""
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_no",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "Agent Yearly report",
    columns: [],
    rows: [],
  };

  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  toggleCol = [];
  menu: any;
  reportTypeList = ["DESIGN NO", "PARTY", "PURCHASE"];

  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  swatchList = ["YES", "NO"];
  sampList = ["YES", "NO"];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private purReport: PurchaseReportService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService,
    private poservice: SalesOrderService
  ) {
    this.filter.po_from_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.filter.po_to_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");

  }

  ngOnInit(): void {
    this.getColumns();
    this.finyearCombo();
    this.loadPartyList();
    // this.codelist();
    // this.colorlist();
    // this.widthlist();
    // this.qualitylist();
    // this.typelist();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
   
    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }
  loadPartyList() {
    let that = this;
    this.combo2Service.purchasePartyCombo().then((res: any) => {
      that.partycodeList = res.data;
    });
  }
  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  exportToExcel($event) {
    console.log(this.exceldata)
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  applyFilter(): void {
    //this.filterExpand = false;
    // this.filterPanel.close();
    $("#type").blur();
    this.filter.coregroupby = "design_wise";
    this.getOrderList();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      that.filter.finyear = res.data[0].finyear;
    });
  }

  // qualitylist() {
  //   this.poservice.qualitylist({}).then((res: any) => {
  //     this.qualityList = res.data;
  //   });
  // }

  // typelist() {
  //   this.poservice.typelist({}).then((res: any) => {
  //     this.typeList = res.data;
  //   });
  // }
  // colorlist() {
  //   this.poservice.colorlist({}).then((res: any) => {
  //     this.colorList = res.data;
  //   });
  // }
  // widthlist() {
  //   this.poservice.widthlist({}).then((res: any) => {
  //     this.widthList = res.data;
  //   });
  // }

  onbackbutton() {
    this.filter.po_id = "";
    this.filter.coregroupby = "design_wise";
    if (this.filter.groupby == "shade_wise") {
      this.filter.groupby = "design_wise";
      this.filter.design_no = "";
    }
    this.getOrderList();
  }

  onCellClick(event) {
    
    if (this.filter.type == "BULK PENDING - ALL PARTY") {
      return false;
    }
    let temp = event.row.po_id;
    this.filter.po_id = temp;
  
    if (this.filter.groupby == "design_wise") {
      this.filter.groupby = "shade_wise";
      this.filter.design_no = event.row.design_no;
    }
    let params = {
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.isLoadMask = that.poservice
      .plainSoreport(params)
      .then(function (res: any) {
       
        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
            
    
        that.printConfig = {
          title: "Purchase Order Report",
          columns: res.columns,
          rows: that.orderList,
        };
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  codelist() {
    this.poservice.codelist({}).then((res: any) => {
      this.partycodeList = res.data;
    });
  }

  getOrderList(): void {
    this.filter.po_from_date = 
      this.datePipe.transform(this.filter.po_from_date, "yyyy-MM-dd");

    this.filter.po_to_date = this.datePipe.transform(
      this.filter.po_to_date,
      "yyyy-MM-dd"
    );
    let params = {
     
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };

    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.poservice
      .plainSoreport(params)
      .then(function (res: any) {
        
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        that.printConfig = {
          title: "Purchase Order Report",
          columns: res.columns,
          rows: that.orderList,
        };
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  getData(columns, data) {

    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/plainSo/plainSostatus.ts